// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';

// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

export const Orders: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity="0.34">
        <rect x="1" y="1" width="3" height="3" rx="1" />
        <rect x="5" y="1" width="10" height="3" rx="1" />
        <rect x="1" y="6" width="3" height="3" rx="1" />
        <rect x="5" y="6" width="10" height="3" rx="1" />
        <rect x="1" y="11" width="3" height="3" rx="1" />
        <rect x="5" y="11" width="10" height="3" rx="1" />
      </g>
    </SvgIcon>
  );
};